import { render, staticRenderFns } from "./CoursewareTreeItemUpdater.vue?vue&type=template&id=11d00f56&"
import script from "./CoursewareTreeItemUpdater.vue?vue&type=script&lang=js&"
export * from "./CoursewareTreeItemUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports